interface ArrowForwardProps {
  className?: string;
}

export default function ArrowForward({ className }: ArrowForwardProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.175 13.7894H4V11.7894H16.175L10.575 6.18943L12 4.78943L20 12.7894L12 20.7894L10.575 19.3894L16.175 13.7894Z"
        fill="currentColor"
      />
    </svg>
  );
}
